import { useEffect, useState } from "react";
import { AccordionDetails, Checkbox, FormControlLabel } from "@mui/material";
import { AccordionComponent } from "../../../StoresModule/Components/Accordion/AccordionComponent";
import { dropdownConfig } from "../../../../services/dropdownsConfigService";
import Input from "../../../../components/Inputs/Input";
import Dropdowns from "../../../../components/Dropdowns/Dropdowns";
import { DateRangeComponent } from "../../../../components/DateRangeComponent/DateRangeComponent";
import CheckboxField from "../../../../components/Checkbox/CheckboxField";
import "./PRFilters.css";
export const PRFilters = ({
  x,
  openChange,
  onApplyFilters,
  hideToggle,
  extOpen,
}) => {
  const [showResults, setShowResults] = useState(false);
  const [closeAccordionWithSearch, setCloseAccordionWithSearch] =
    useState(false);
  const [basicFilters, setBasicFilters] = useState([]);
  const [activeDropdownIndex, setActiveDropdownIndex] = useState(-1); // Inicia en 0 (primer dropdown);
  const [txtFilters, setTxtFilters] = useState({});

  const [dateRangeSelected, setDateRangeSelected] = useState(null);
  const [dateRequestedRangeSelected, setDateRequestedRangeSelected] =
    useState(null);
  const dropdownsConfigId = [104, 1, 100, 2, 3, 93, 90, 89, 87, 102, 88, 61];
  const prnDropdowns = [104, 1, 100, 2, 3, 93, 90, 89, 87, 102, 88, 61];
  const orderDropdowns = [];
  const [resetDateRange, setResetDateRange] = useState(0);
  const [fitlersToApply, setFiltersToApply] = useState({});
  const [wpParameter, _] = useState([
    { columnName: "wpId", value: null },
  ])
  const [dataCompanyDrop, setDataCompanyDrop] = useState([]);
  useEffect(() => {
    openChange?.(showResults);
  }, [showResults]);

  useEffect(() => {
    setDataCompanyDrop(() => JSON.parse(localStorage.getItem("u_companies")));
    setCloseAccordionWithSearch(extOpen);
  }, [extOpen]);

  const txtChange = (e) => {
    let { name, value } = e.target;
    setTxtFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleTabNavigation = (event) => {};

  const getDropdownsConfig = async () => {
    try {
      const responses = await Promise.all(
        dropdownsConfigId.map(async (e) => {
          const req = await dropdownConfig(e);
          if (req.data.responseCode === 200) {
            return req.data.load;
          }

          return null;
        })
      );

      const validData = responses.filter((data) => data !== null);

      basicFilters.length <= 0
        ? setBasicFilters((prevData) => [...prevData, ...validData])
        : null;
    } catch (error) {
      console.error("Error fetching dropdown configs:", error);
    }
  };

  const handleCloseAccordion = () => {
    onApplyFilters?.(fitlersToApply, txtFilters);
    setCloseAccordionWithSearch((prevState) => !prevState);
    setShowResults(!showResults);
  };

  const simpleDropdownApply = () => {
    onApplyFilters?.(fitlersToApply, txtFilters);
    setShowResults((prev) => (prev ? !prev : prev));
  };

  const updateDropdown = (dropdownId, parentValues, dependenciesToUpdate) => {
    setBasicFilters((prevFilters) =>
      prevFilters.map((filter) => {
        if (filter.id === dropdownId) {
          return {
            ...filter,
            parentValues,
            dependenciesToUpdate,
            reload: true,
          };
        }
        return filter;
      })
    );
  };

  const resetDropdownsReload = () => {
    setBasicFilters((filterState) => {
      if (filterState.length > 0) {
        return filterState.map((e) => {
          if (e.reload) {
            return { ...e, reload: false };
          }
          return e;
        });
      }
      return filterState;
    });
  };

  const selectOption = (values, filter) => {
    setFiltersToApply((prev) => ({ ...prev, [filter.id]: values }));
  };

  useEffect(() => {}, [fitlersToApply]);

  useEffect(() => {
    window.addEventListener("keydown", handleTabNavigation);
    return () => {
      window.removeEventListener("keydown", handleTabNavigation);
    };
  }, [basicFilters.length]);

  useEffect(() => {
    try {
      getDropdownsConfig();
    } catch (error) {
      console.error(error);
    }
  }, []);
  const handleSelectAll = (checked, filterId) => {};
  const handleDateRange = (range) => {
    setDateRangeSelected(range);
  };
  const handleDateRequestedRange = (range) => {
    setDateRequestedRangeSelected(range);
  };
  return (
    <>
      <div className="filters-component">
        <AccordionComponent
          title="Filters"
          changeOpen={closeAccordionWithSearch}
          hideToggle={hideToggle}
        >
          <AccordionDetails sx={{ padding: "0" }}>
            <div className="filter-all-cont">
              {/* basic filters section */}

              <section className="basicFilters-cont">
                <h2>Parts Request Filter</h2>
                <div className="inputs-basicFilters-cont">
                  {basicFilters.length <= 0 ? (
                    <p className="loading-dropdowns">Loading Dropdowns...</p>
                  ) : (
                    basicFilters.map((filter, index) => {
                      if (filter.id === 61) {
                        return (
                          dataCompanyDrop?.length > 0 && (
                            <Dropdowns
                              updateDropdown={updateDropdown}
                              resetDropdownsReload={resetDropdownsReload}
                              key={61}
                              onAllOptionsSelected={(values) =>
                                selectOption(values, 61)
                              }
                              isStatic={true}
                              staticData={dataCompanyDrop}
                              staticDataColumnPreselection={"id"}
                              data={filter}
                              onApplySelection={simpleDropdownApply}
                            />
                          )
                        );
                      } else {
                        return (
                          prnDropdowns.includes(filter.id) && (
                            <Dropdowns
                              key={index}
                              data={filter}
                              parameters={wpParameter}
                              currentIndexTab={activeDropdownIndex === index}
                              updateDropdown={updateDropdown}
                              resetDropdownsReload={resetDropdownsReload}
                              onAllOptionsSelected={(values) =>
                                selectOption(values, filter)
                              }
                              onApplySelection={simpleDropdownApply}
                            />
                          )
                        );
                      }
                    })
                  )}
                  <div
                    style={{
                      border: "none",
                      padding: "0",
                      width: "100%",
                      gridColumn: "span 2",
                    }}
                  >
                    <DateRangeComponent
                      label="Required Date"
                      getDateRange={handleDateRange}
                      resetRange={resetDateRange}
                    />
                  </div>
                  <CheckboxField
                    disabled={false}
                    outlined
                    checked={false}
                    onChange={(checked) =>
                      handleSelectAll(checked, "freeOfCharge")
                    }
                  >
                    <span>See all PRN</span>
                  </CheckboxField>
                </div>
                {/* <section className="advance-filters-sect2">
                  <h2>Order Filter</h2>
                  <section>
                    {basicFilters?.map((filter, index) => {
                      // renderizado de los dropdowns
                      return (
                        orderDropdowns.includes(filter.id) && (
                          <Dropdowns
                            // selectionLabel={selectionLabels[filter.id]}
                            optionLabel="description"
                            key={index}
                            data={filter}
                            currentIndexTab={activeDropdownIndex === index}
                            updateDropdown={updateDropdown}
                            resetDropdownsReload={resetDropdownsReload}
                            onAllOptionsSelected={(values) =>
                              selectOption(values, filter)
                            }
                            onApplySelection={simpleDropdownApply}
                          ></Dropdowns>
                        )
                      );
                    })}
                    <div
                      style={{
                        border: "none",
                        padding: "0",
                        gridColumn: "span 2",
                      }}
                    >
                      <DateRangeComponent
                        label="Delivery Date"
                        getDateRange={handleDateRange}
                        resetRange={resetDateRange}
                      />
                    </div>

                    <div
                      style={{
                        border: "none",
                        padding: "0",
                        gridColumn: "span 2",
                      }}
                    >
                      <DateRangeComponent
                        label="Received Date"
                        getDateRange={handleDateRequestedRange}
                        resetRange={resetDateRange}
                      />
                    </div>
                  </section>
                </section> */}
                <div className="footer-basicFilters">
                <button
                  className="btn-search-prn-filter"
                  onClick={handleCloseAccordion}
                >
                  <svg
                    id="Group_968"
                    data-name="Group 968"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 18.998 18.999"
                  >
                    <g id="Group_809" data-name="Group 809">
                      <path
                        id="Path_642"
                        data-name="Path 642"
                        d="M1337.771,45.422A6.475,6.475,0,1,1,1331.3,51.9a6.482,6.482,0,0,1,6.474-6.475m0-1.5a7.975,7.975,0,1,0,7.975,7.975,7.975,7.975,0,0,0-7.975-7.975Z"
                        transform="translate(-1329.797 -43.922)"
                        fill="#fff"
                      />
                      <path
                        id="Línea_80"
                        data-name="Línea 80"
                        d="M4.6,5.347a.748.748,0,0,1-.53-.22L-.53.53A.75.75,0,0,1-.53-.53.75.75,0,0,1,.53-.53l4.6,4.6a.75.75,0,0,1-.53,1.28Z"
                        transform="translate(13.651 13.652)"
                        fill="#fff"
                      />
                    </g>
                  </svg>
                  Search
                </button></div>
              </section>
            </div>
          </AccordionDetails>
        </AccordionComponent>
      </div>
      <hr />
    </>
  );
};
